(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["teeinblue-sticky-mobile"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wauzy-sticky-preview')) {
    class WauzyStickyPreview extends HTMLElement {
      connectedCallback() {
        this.startTimer = setTimeout(() => this.start(), 0);
      }

      start() {
        if (!this.isConnected || this.abort || document.querySelector('.wz-sp-panel')) return;
        const template = this.querySelector('template');
        if (!template) return;
        this.abort = new AbortController();
        this.mobile = matchMedia('(max-width: 749px)');
        this.compact = Math.min(40, Math.max(20, Number(this.dataset.compact) || 30)) / 100;
        this.large = Math.max(this.compact, Math.min(60, Number(this.dataset.expanded) || 50) / 100);
        this.offset = Math.max(0, Number(this.dataset.offset) || 0);
        this.isExpanded = false;
        this.dismissed = false;
        const fragment = template.content.cloneNode(true);
        this.panel = fragment.querySelector('.wz-sp-panel');
        this.restoreButton = fragment.querySelector('.wz-sp-restore');
        this.stage = this.panel.querySelector('.wz-sp-stage');
        this.handle = this.panel.querySelector('.wz-sp-handle');
        this.action = this.panel.querySelector('.wz-sp-action');
        for (const node of [this.panel, this.restoreButton]) {
          node.style.setProperty('--wz-sp-bg', this.dataset.background);
          node.style.setProperty('--wz-sp-accent', this.dataset.accent);
          node.style.setProperty('--wz-sp-offset', `${this.offset}px`);
        }
        document.body.append(fragment);
        this.on(window, 'scroll', () => this.schedule(), { passive: true });
        this.on(window, 'resize', () => this.viewportChanged(), { passive: true });
        this.on(this.mobile, 'change', () => this.viewportChanged());
        if (window.visualViewport) {
          this.on(visualViewport, 'resize', () => this.viewportChanged(), { passive: true });
          this.on(visualViewport, 'scroll', () => this.schedule(), { passive: true });
        }
        this.on(this.handle, 'click', event => {
          if (event.detail && performance.now() < (this.ignoreClickUntil || 0)) return;
          this.expand(!this.isExpanded);
        });
        this.on(this.handle, 'keydown', event => {
          if (!['ArrowDown', 'ArrowUp', 'Escape'].includes(event.key)) return;
          event.preventDefault();
          this.expand(event.key === 'ArrowDown');
        });
        this.on(this.handle, 'pointerdown', event => this.dragStart(event));
        this.on(this.handle, 'pointermove', event => this.dragMove(event));
        this.on(this.handle, 'pointerup', event => this.dragEnd(event));
        this.on(this.handle, 'pointercancel', () => this.cancelDrag());
        this.on(this.handle, 'lostpointercapture', () => this.cancelDrag());
        this.on(this.panel.querySelector('.wz-sp-close'), 'click', () => {
          this.dismissed = true;
          this.schedule();
          requestAnimationFrame(() => this.restoreButton.focus({ preventScroll: true }));
        });
        this.on(this.restoreButton, 'click', () => {
          this.dismissed = false;
          this.schedule();
          requestAnimationFrame(() => this.handle.focus({ preventScroll: true }));
        });
        this.on(document, 'focusin', event => {
          if (event.target.matches('input:not([type="radio"]):not([type="checkbox"]), textarea, [contenteditable="true"]')) {
            this.expand(false);
            clearTimeout(this.focusTimer);
            this.focusTimer = setTimeout(() => this.revealFocusedField(), 300);
          }
        });
        this.on(document, 'click', () => {
          this.schedule();
          clearTimeout(this.dialogTimer);
          this.dialogTimer = setTimeout(() => this.schedule(), 300);
        }, { passive: true });
        this.on(this.panel, 'transitionend', () => this.fit());
        this.observer = new MutationObserver(() => this.schedule());
        this.observer.observe(document.body, { childList: true, subtree: true });
        this.resizeObserver = new ResizeObserver(() => {
          this.fit();
          this.schedule();
        });
        this.resizeObserver.observe(this.stage);
        this.updateLabel();
        this.schedule();
      }

      on(target, type, callback, options = {}) {
        target?.addEventListener(type, callback, { ...options, signal: this.abort.signal });
      }

      viewport() {
        return window.visualViewport?.height || window.innerHeight;
      }

      heights() {
        const available = Math.max(0, this.viewport() - this.offset);
        return [Math.min(available, this.viewport() * this.compact), Math.min(available, this.viewport() * this.large)];
      }

      schedule() {
        if (this.frame || !this.abort) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      }

      viewportChanged() {
        this.cancelDrag();
        if (!this.mobile.matches || (this.source && Math.abs(innerWidth - this.viewportWidth) > 2)) this.release();
        this.schedule();
      }

      bind() {
        if (this.source && (!this.source.isConnected || !this.placeholder.isConnected)) this.release();
        if (this.source) return true;
        const gallery = document.querySelector('main #tee-gallery');
        const form = document.querySelector('main #tee-artwork-form');
        if (!gallery || !form) return false;
        const wrapper = gallery.closest('.tee-gallery-content');
        this.source = wrapper || gallery;
        if (!this.source.getBoundingClientRect().height) { this.source = null; return false; }
        this.form = form;
        this.placeholder = document.createElement('div');
        this.placeholder.className = 'wz-sp-placeholder';
        this.placeholder.hidden = true;
        this.placeholder.setAttribute('aria-hidden', 'true');
        this.source.before(this.placeholder);
        this.resizeObserver.observe(this.source);
        this.viewportWidth = innerWidth;
        return true;
      }

      modalOpen() {
        return [...document.querySelectorAll('dialog[open], .drawer[open], [role="dialog"][aria-modal="true"], .tee-dialog-image-placement, .show-pop-up')].some(node => {
          const style = getComputedStyle(node);
          const rect = node.getBoundingClientRect();
          return rect.width > 0 && rect.height > 0 && style.visibility !== 'hidden' && style.display !== 'none' && Number(style.opacity) !== 0;
        });
      }

      update() {
        if (!this.mobile.matches || !this.bind()) {
          this.deactivate();
          return;
        }
        if (!this.form.isConnected) {
          this.release();
          this.schedule();
          return;
        }
        const inputs = this.form.querySelector('#teeFormInputs');
        const personalization = inputs?.closest('.tee-customize-main-form') || inputs;
        const personalizationRect = personalization?.getBoundingClientRect();
        if (!personalizationRect?.height) {
          this.deactivate();
          return;
        }
        const [small, large] = this.heights();
        const height = this.isExpanded ? large : small;
        const formRect = this.form.getBoundingClientRect();
        const threshold = this.offset + small;
        const keyboardZoom = window.visualViewport && Math.abs(visualViewport.scale - 1) > .05;
        const shouldStick = personalizationRect.top <= threshold + (this.active ? 48 : 0)
          && formRect.bottom > this.offset + large + 80 - (this.active ? 48 : 0)
          && height >= 110 && !keyboardZoom;
        if (!shouldStick) {
          this.deactivate();
          return;
        }
        if (!this.active) this.activate();
        if (!this.active) return;
        const modal = this.modalOpen();
        this.panel.hidden = this.dismissed || modal;
        this.restoreButton.hidden = !this.dismissed || modal;
        this.setHeight(this.drag ? this.drag.height : height);
        this.fit();
      }

      activate() {
        const rect = this.source.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        this.hiddenSiblings = [...this.source.parentElement.children].filter(node => node !== this.source && node !== this.placeholder && getComputedStyle(node).display === 'none');
        this.hiddenSiblings.forEach(node => node.classList.add('wz-sp-preserve-hidden'));
        this.placeholder.style.height = `${rect.height}px`;
        this.placeholder.style.marginTop = getComputedStyle(this.source).marginTop;
        this.placeholder.style.marginBottom = getComputedStyle(this.source).marginBottom;
        this.placeholder.hidden = false;
        this.panel.style.setProperty('--wz-sp-width', `${rect.width}px`);
        this.source.classList.add('wz-sp-source');
        this.stage.append(this.source);
        this.active = true;
        this.panel.hidden = this.dismissed;
      }

      deactivate() {
        this.cancelDrag();
        if (this.active && this.placeholder?.isConnected && this.source) {
          this.placeholder.after(this.source);
          this.source.classList.remove('wz-sp-source');
          this.placeholder.removeAttribute('style');
        }
        if (this.placeholder) this.placeholder.hidden = true;
        this.hiddenSiblings?.forEach(node => node.classList.remove('wz-sp-preserve-hidden'));
        this.hiddenSiblings = null;
        this.active = false;
        if (this.panel) this.panel.hidden = true;
        if (this.restoreButton) this.restoreButton.hidden = true;
        document.documentElement.style.removeProperty('--wz-sp-scroll-height');
      }

      release() {
        this.deactivate();
        if (this.source) {
          this.resizeObserver?.unobserve(this.source);
          this.source.classList.remove('wz-sp-source');
          if (this.stage?.contains(this.source)) this.source.remove();
        }
        this.placeholder?.remove();
        this.source = null;
        this.placeholder = null;
        this.form = null;
      }

      setHeight(height) {
        const value = `${Math.round(height)}px`;
        if (this.panel.style.getPropertyValue('--wz-sp-height') !== value) this.panel.style.setProperty('--wz-sp-height', value);
        if (!this.panel.hidden) document.documentElement.style.setProperty('--wz-sp-scroll-height', `${Math.round(height + this.offset)}px`);
        else document.documentElement.style.removeProperty('--wz-sp-scroll-height');
      }

      fit() {
        if (!this.active || this.panel.hidden || !this.source) return;
        const width = this.source.offsetWidth;
        const height = this.source.offsetHeight;
        if (!width || !height) return;
        const scale = Math.max(.05, Math.min(1, this.stage.clientWidth / width, this.stage.clientHeight / height));
        const value = scale.toFixed(5);
        if (this.panel.style.getPropertyValue('--wz-sp-scale') !== value) this.panel.style.setProperty('--wz-sp-scale', value);
      }

      updateLabel() {
        const label = this.isExpanded ? this.dataset.collapseLabel : this.dataset.expandLabel;
        this.handle.setAttribute('aria-expanded', String(this.isExpanded));
        this.handle.setAttribute('aria-label', label);
        if (this.action.textContent !== label) this.action.textContent = label;
      }

      expand(value) {
        this.isExpanded = value;
        this.updateLabel();
        this.schedule();
      }

      dragStart(event) {
        if (!event.isPrimary || event.button !== 0 || !this.active) return;
        this.drag = { id: event.pointerId, y: event.clientY, time: performance.now(), start: this.panel.getBoundingClientRect().height, height: this.panel.getBoundingClientRect().height };
        this.handle.setPointerCapture(event.pointerId);
      }

      dragMove(event) {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const delta = event.clientY - this.drag.y;
        if (Math.abs(delta) < 6 && !this.drag.moved) return;
        this.drag.moved = true;
        const [small, large] = this.heights();
        this.drag.height = Math.max(small, Math.min(large, this.drag.start + delta));
        this.panel.classList.add('is-dragging');
        this.setHeight(this.drag.height);
        this.fit();
      }

      dragEnd(event) {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const gesture = this.drag;
        const delta = event.clientY - gesture.y;
        const speed = delta / Math.max(1, performance.now() - gesture.time);
        this.drag = null;
        this.panel.classList.remove('is-dragging');
        if (gesture.moved) {
          this.ignoreClickUntil = performance.now() + 400;
          const [small, large] = this.heights();
          this.expand(Math.abs(delta) > 24 || Math.abs(speed) > .3 ? delta > 0 : gesture.height > (small + large) / 2);
        }
        if (this.handle.hasPointerCapture(event.pointerId)) this.handle.releasePointerCapture(event.pointerId);
        this.schedule();
      }

      cancelDrag() {
        if (!this.drag) return;
        const id = this.drag.id;
        this.drag = null;
        this.panel.classList.remove('is-dragging');
        if (this.handle.hasPointerCapture(id)) this.handle.releasePointerCapture(id);
        const [small, large] = this.heights();
        this.setHeight(this.isExpanded ? large : small);
        this.fit();
      }

      revealFocusedField() {
        if (!this.active || this.panel.hidden) return;
        const field = document.activeElement;
        if (!this.form?.contains(field)) return;
        const limit = this.panel.getBoundingClientRect().bottom + 16;
        const top = field.getBoundingClientRect().top;
        if (top < limit) window.scrollBy({ top: top - limit, behavior: 'instant' });
      }

      disconnectedCallback() {
        clearTimeout(this.startTimer);
        clearTimeout(this.focusTimer);
        clearTimeout(this.dialogTimer);
        cancelAnimationFrame(this.frame);
        this.abort?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.release();
        this.panel?.remove();
        this.restoreButton?.remove();
        this.abort = null;
      }
    }
    customElements.define('wauzy-sticky-preview', WauzyStickyPreview);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teeinblue-stil"] && !Shopify.designMode) return;
  try {
    
(() => {
  const raw = new URLSearchParams(window.location.search).get('stil');
  if (!raw || !/^[1-9]\d*$/.test(raw)) return;
  const position = Number(raw);
  if (!Number.isSafeInteger(position) || window.__teeStilStarted) return;
  window.__teeStilStarted = true;

  const scope = '#teeFormInputs, .tee-form-inputs, #teeinblue-form';
  const events = ['pointerdown', 'keydown', 'input', 'change'];
  let stopped = false;
  let frame = 0;
  let retry = 0;
  let applying = false;

  function stop() {
    stopped = true;
    observer.disconnect();
    clearTimeout(deadline);
    clearTimeout(retry);
    cancelAnimationFrame(frame);
    events.forEach(type => document.removeEventListener(type, onUser, true));
  }

  function onUser(event) {
    if (event.isTrusted && event.target instanceof Element && event.target.closest(scope)) stop();
  }

  function visible(element) {
    return !element.closest('[hidden], .sr-only, .visually-hidden') &&
      element.getClientRects().length > 0 &&
      getComputedStyle(element).visibility === 'visible';
  }

  function schedule() {
    if (!stopped && !frame && !applying) frame = requestAnimationFrame(apply);
  }

  function apply() {
    frame = 0;
    if (stopped) return;
    const fields = [...document.querySelectorAll(scope)]
      .flatMap(root => [...root.querySelectorAll('.tee-custom-select, select')]);
    const dropdown = fields.find(element => visible(element) &&
      !element.matches(':disabled, [aria-disabled="true"]') &&
      !(element.matches('select') && element.closest('.tee-custom-select')));
    if (!dropdown) return;

    let selected;
    let choose;
    if (dropdown.matches('select')) {
      const options = [...dropdown.options].filter(option =>
        !option.matches(':disabled') && !option.hidden &&
        option.value !== '' && option.value !== 'null');
      const option = options[position - 1];
      if (!option) return;
      selected = () => dropdown.isConnected && dropdown.selectedIndex === option.index;
      choose = () => {
        dropdown.selectedIndex = option.index;
        dropdown.dispatchEvent(new Event('input', { bubbles: true }));
        dropdown.dispatchEvent(new Event('change', { bubbles: true }));
      };
    } else {
      const options = [...dropdown.querySelectorAll('.tee-custom-select-item')]
        .filter(option => !option.hidden &&
          !option.closest('[aria-disabled="true"], [disabled]'));
      const option = options[position - 1];
      if (!option) return;
      selected = () => option.isConnected &&
        (option.classList.contains('tee-active') || option.getAttribute('aria-selected') === 'true');
      choose = () => option.click();
    }

    if (selected()) return stop();
    applying = true;
    choose();
    retry = setTimeout(() => {
      applying = false;
      if (stopped) return;
      if (selected()) stop();
      else schedule();
    }, 100);
  }

  const observer = new MutationObserver(schedule);
  const deadline = setTimeout(stop, 30000);
  events.forEach(type => document.addEventListener(type, onUser, true));
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'hidden', 'disabled', 'aria-disabled']
  });
  schedule();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teeinblue_upload_guard"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('teeinblue-upload-guard')) {
    class TeeinblueUploadGuard extends HTMLElement {
      connectedCallback() {
        if (this.controller || TeeinblueUploadGuard.owner) return;
        this.editor = this.dataset.editor === 'true';
        if (this.dataset.active !== 'true' && !this.editor) return;
        TeeinblueUploadGuard.owner = this;
        this.controller = new AbortController();
        this.notes = new Map();
        this.pairedEvents = new WeakMap();
        this.memoryAttempts = [];
        this.storageBroken = false;
        this.transient = null;
        this.limit = Math.max(1, Number(this.dataset.limit) || 5);
        this.windowMs = Math.max(1, Number(this.dataset.hours) || 24) * 3600000;
        this.cooldownMs = Math.max(0, Number(this.dataset.cooldown) || 0) * 1000;
        this.storageKey = 'teeinblue-upload-guard:v1:' + this.dataset.shop + ':' +
          (this.dataset.scope === 'product' ? this.dataset.product : 'shared');
        this.selector = this.dataset.selector.trim();
        try {
          if (!this.selector) throw new Error('Empty selector');
          document.querySelectorAll(this.selector);
        } catch {
          this.setDiagnostic(this.dataset.configText);
          return;
        }
        this.schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.render();
          });
        };
        const signal = this.controller.signal;
        if (!this.editor) {
          for (const type of ['input', 'change']) {
            window.addEventListener(type, event => this.onSelection(event), { capture: true, signal });
          }
          for (const type of ['click', 'keydown']) {
            window.addEventListener(type, event => this.onOpen(event), { capture: true, signal });
          }
          for (const type of ['drop', 'paste']) {
            window.addEventListener(type, event => this.onAlternativeUpload(event), { capture: true, signal });
          }
          window.addEventListener('storage', event => {
            if (event.key === this.storageKey || event.key === null) this.schedule();
          }, { signal });
          window.addEventListener('pageshow', this.schedule, { signal });
          document.addEventListener('visibilitychange', this.schedule, { signal });
        }
        this.observer = new MutationObserver(this.schedule);
        this.observer.observe(document.body, { childList: true, subtree: true });
        this.timer = setInterval(this.schedule, 1000);
        this.render();
      }

      disconnectedCallback() {
        if (!this.controller) return;
        this.controller.abort();
        this.controller = null;
        this.observer?.disconnect();
        clearInterval(this.timer);
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        for (const note of this.notes.values()) note.remove();
        this.notes.clear();
        if (TeeinblueUploadGuard.owner === this) TeeinblueUploadGuard.owner = null;
      }

      setDiagnostic(text) {
        const node = this.querySelector('[data-guard-diagnostic]');
        if (node && node.textContent !== text) node.textContent = text;
      }

      inputs() {
        return Array.from(document.querySelectorAll(this.selector)).filter(input =>
          input instanceof HTMLInputElement && input.type === 'file');
      }

      protects(input) {
        return input instanceof HTMLInputElement && input.type === 'file' && input.matches(this.selector);
      }

      readAttempts(now = Date.now()) {
        let stored = [];
        try {
          const raw = localStorage.getItem(this.storageKey);
          if (raw) {
            const parsed = JSON.parse(raw);
            if (!Array.isArray(parsed) || parsed.some(item =>
              !item || typeof item.id !== 'string' || !Number.isFinite(item.at))) {
              throw new Error('Invalid counter');
            }
            stored = parsed;
          }
        } catch {
          this.storageBroken = true;
        }
        const unique = new Map();
        for (const item of [...stored, ...this.memoryAttempts]) {
          if (item.at > now - this.windowMs && item.at <= now) unique.set(item.id, item);
        }
        const attempts = Array.from(unique.values()).sort((a, b) => a.at - b.at);
        this.memoryAttempts = attempts;
        return attempts;
      }

      state(now = Date.now()) {
        const attempts = this.readAttempts(now);
        const remaining = Math.max(0, this.limit - attempts.length);
        const resetAt = remaining === 0 ? attempts[attempts.length - this.limit].at + this.windowMs : 0;
        const last = attempts.at(-1)?.at || 0;
        const cooldownUntil = last ? last + this.cooldownMs : 0;
        return { attempts, remaining, resetAt, cooldownUntil, now };
      }

      tokens(text, state) {
        return text.replaceAll('{remaining}', String(state.remaining))
          .replaceAll('{limit}', String(this.limit))
          .replaceAll('{hours}', String(this.windowMs / 3600000))
          .replaceAll('{minutes}', String(Math.max(1, Math.ceil((state.resetAt - state.now) / 60000))))
          .replaceAll('{seconds}', String(Math.max(1, Math.ceil((state.cooldownUntil - state.now) / 1000))));
      }

      reason(state) {
        if (this.storageBroken) return this.dataset.storageText;
        if (state.remaining === 0) return this.tokens(this.dataset.limitText, state);
        if (state.cooldownUntil > state.now) return this.tokens(this.dataset.cooldownText, state);
        return '';
      }

      stop(event, message, clearInput = false) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (clearInput && event.target instanceof HTMLInputElement) event.target.value = '';
        this.transient = { text: message, until: Date.now() + 8000 };
        this.render();
      }

      onSelection(event) {
        const input = event.target;
        if (!this.protects(input) || !input.files?.length) return;
        const files = Array.from(input.files);
        const now = Date.now();
        const paired = this.pairedEvents.get(input);
        if (paired && paired.type !== event.type && now - paired.at < 1000 &&
            files.length === paired.files.length && files.every((file, index) => file === paired.files[index])) {
          this.pairedEvents.delete(input);
          return;
        }
        const state = this.state(now);
        const reason = this.reason(state);
        if (reason) {
          this.stop(event, reason, true);
          return;
        }
        if (files.length > state.remaining) {
          this.stop(event, this.tokens(this.dataset.selectionText, state), true);
          return;
        }
        const additions = files.map(() => ({ at: now, id: crypto.randomUUID() }));
        const attempts = [...state.attempts, ...additions];
        try {
          localStorage.setItem(this.storageKey, JSON.stringify(attempts));
        } catch {
          this.storageBroken = true;
          this.stop(event, this.dataset.storageText, true);
          return;
        }
        this.memoryAttempts = attempts;
        this.pairedEvents.set(input, { files, at: now, type: event.type });
        this.transient = null;
        this.schedule();
      }

      openingInput(target) {
        if (!(target instanceof Element)) return null;
        const input = target.closest('input[type="file"]');
        if (this.protects(input)) return input;
        const label = target.closest('label[for]');
        if (label) {
          const labelledInput = document.getElementById(label.htmlFor);
          if (this.protects(labelledInput)) return labelledInput;
        }
        return null;
      }

      onOpen(event) {
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
        if (!this.openingInput(event.target)) return;
        const reason = this.reason(this.state());
        if (reason) this.stop(event, reason);
      }

      onAlternativeUpload(event) {
        if (!(event.target instanceof Element)) return;
        const zone = event.target.closest('.tee-photo, .tee-field--photo');
        if (!zone || !Array.from(zone.querySelectorAll('input[type="file"]')).some(input => this.protects(input))) return;
        const transfer = event.dataTransfer || event.clipboardData;
        const hasFiles = transfer && (transfer.files?.length ||
          Array.from(transfer.items || []).some(item => item.kind === 'file'));
        if (hasFiles) this.stop(event, this.dataset.methodText);
      }

      render() {
        const inputs = this.inputs();
        this.setDiagnostic(inputs.length ?
          this.dataset.diagnosticText.replaceAll('{count}', String(inputs.length)) : this.dataset.missingText);
        if (this.editor) return;
        const state = this.state();
        const reason = this.reason(state);
        const transient = this.transient?.until > state.now ? this.transient.text : '';
        const text = reason || transient || this.tokens(this.dataset.notice, state);
        const blocked = Boolean(reason || transient);
        const parents = new Set(inputs.map(input => input.closest('.tee-photo') || input.parentElement));
        for (const [parent, note] of this.notes) {
          if (!parent.isConnected || !parents.has(parent)) {
            note.remove();
            this.notes.delete(parent);
          }
        }
        for (const parent of parents) {
          let note = this.notes.get(parent);
          if (!note) {
            note = document.createElement('p');
            note.className = 'tee-upload-guard-note';
            note.setAttribute('role', 'status');
            note.setAttribute('aria-live', 'polite');
            note.setAttribute('aria-atomic', 'true');
            parent.prepend(note);
            this.notes.set(parent, note);
          } else if (!parent.contains(note)) {
            parent.prepend(note);
          }
          if (note.textContent !== text) note.textContent = text;
          note.dataset.blocked = String(blocked);
          note.hidden = !blocked && this.dataset.showRemaining !== 'true';
        }
      }
    }
    customElements.define('teeinblue-upload-guard', TeeinblueUploadGuard);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wauzy-aufhaengung"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('wauzy-mounting-config')) return;
  const controllers = new Set();
  const frameSkus = Object.freeze({ '40x30':'BACKFRAME-40-30', '60x40':'BACKFRAME-60-40', '80x60':'BACKFRAME-80-60', '100x75':'BACKFRAME-100-75', '120x80':'BACKFRAME-120-80' });
  const dimension = value => {
    const match = String(value || '').match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i);
    if (!match) return '';
    return match.slice(1).map(n => Number(n.replace(',','.'))).sort((a,b) => b-a).join('x');
  };
  const isAcrylic = variant => /^ACRYL-/i.test(variant?.sku || '');
  const sizeOf = variant => dimension(variant?.options?.find(value => dimension(value)) || variant?.sku);
  const lineItems = payload => Array.isArray(payload) ? payload : Array.isArray(payload?.items) ? payload.items : payload?.id ? [payload] : [];
  let currentHook;
  function installHook() {
    const tib = window.teeinblue;
    if (!tib || typeof tib !== 'object') return false;
    if (currentHook && tib.transformBeforeAddToCart === currentHook) return true;
    const previous = tib.transformBeforeAddToCart;
    currentHook = async function(payload) {
      const controller = [...controllers].find(item => item.owns(payload));
      const snapshot = controller?.snapshot(payload);
      const transformed = typeof previous === 'function' ? await previous.call(this,payload) : payload;
      if (!snapshot) return transformed;
      try { return await controller.attach(transformed,snapshot); }
      catch (error) { controller.showError(error.message || controller.labels.error); throw error; }
    };
    tib.transformBeforeAddToCart = currentHook;
    return true;
  }
  class WauzyMounting extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const config = this.querySelector('[data-mount-config]');
      const template = this.querySelector('[data-mount-template]');
      if (!config || !template) return;
      try { this.config = JSON.parse(config.textContent); } catch { return; }
      this.ready = true;
      this.labels = this.config.labels;
      this.variants = new Map(this.config.variants.map(variant => [String(variant.id),variant]));
      this.choice = 'none';
      this.ui = template.content.firstElementChild.cloneNode(true);
      this.ui.dataset.mountOwner = this.dataset.sectionId;
      this.money = new Intl.NumberFormat(this.config.language,{style:'currency',currency:this.config.currency});
      this.ui.addEventListener('change', event => {
        if (!event.target.matches('.wz-mount__radio') || event.target.disabled) return;
        this.choice = event.target.value;
        this.message('[data-mount-error]','');
        this.message('[data-mount-notice]','');
        this.sync();
      });
      this.onChange = event => {
        if (event.target.closest?.('#tee-artwork-form') && !event.target.closest('.wz-mount')) this.schedule();
      };
      this.onHistory = () => this.schedule();
      document.addEventListener('change',this.onChange);
      window.addEventListener('popstate',this.onHistory);
      this.observer = new MutationObserver(records => {
        if (records.some(record => {
          const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
          if (target?.closest('.wz-mount')) return false;
          if (target?.closest('#tee-artwork-form')) return true;
          return [...record.addedNodes,...record.removedNodes].some(node => node.nodeType === 1 && (node.matches('#tee-artwork-form') || node.querySelector('#tee-artwork-form')));
        })) this.schedule();
      });
      this.observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class','value','disabled'],characterData:true});
      controllers.add(this);
      this.schedule();
      this.retry = setInterval(() => { if (this.form && installHook()) { clearInterval(this.retry); this.retry = null; } this.schedule(); },500);
      this.retryStop = setTimeout(() => { clearInterval(this.retry); this.retry = null; },20000);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('change',this.onChange);
      window.removeEventListener('popstate',this.onHistory);
      cancelAnimationFrame(this.frame);
      clearInterval(this.retry);
      clearTimeout(this.retryStop);
      this.ui?.remove();
      controllers.delete(this);
      this.ready = false;
    }
    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; if (this.isConnected) this.sync(); });
    }
    selectedVariant() {
      const id = new URL(window.location.href).searchParams.get('variant') || this.config.initialVariantId;
      const variant = this.variants.get(String(id));
      const selectedSize = this.form?.querySelector('.tee-option--size .active input')?.value || this.form?.querySelector('.tee-option--size select')?.value;
      if (selectedSize && dimension(selectedSize) && dimension(selectedSize) !== sizeOf(variant)) return null;
      return variant;
    }
    accessory(kind,variant) {
      if (!isAcrylic(variant)) return null;
      const size = sizeOf(variant);
      const sku = kind === 'plate' ? this.config.plateSku : kind === 'frame' ? frameSkus[size] : null;
      if (!sku || !this.config.accessories[kind]?.handle) return null;
      const matches = this.config.accessories[kind].variants.filter(item => item.sku === sku);
      if (matches.length !== 1 || !matches[0].available || !Number.isFinite(matches[0].price) || matches[0].price <= 0) return null;
      return matches[0];
    }
    sync() {
      this.form = document.querySelector('#tee-artwork-form');
      const anchor = this.form?.querySelector('.tee-btn--preview')?.closest('.tee-form-action') || this.form?.querySelector('#teeAtcButton')?.closest('.tee-form-atc-wrapper');
      if (!anchor) { this.ui.hidden = true; return; }
      if (anchor.previousElementSibling !== this.ui) anchor.before(this.ui);
      const variant = this.selectedVariant();
      const visible = isAcrylic(variant) && installHook();
      if (this.ui.hidden === visible) this.ui.hidden = !visible;
      const materialChanged = variant && !isAcrylic(variant);
      if (materialChanged) this.choice = 'none';
      if (variant && this.choice !== 'none' && !this.accessory(this.choice,variant)) {
        this.choice = 'none';
        this.message('[data-mount-notice]',this.labels.reset);
      }
      for (const kind of ['none','plate','frame']) {
        const input = this.ui.querySelector(`input[value="${kind}"]`);
        const item = kind !== 'none' ? this.accessory(kind,variant) : null;
        const disabled = kind !== 'none' && !item;
        if (input.disabled !== disabled) input.disabled = disabled;
        if (input.checked !== (this.choice === kind)) input.checked = this.choice === kind;
        const card = input.closest('.wz-mount__choice');
        if (card.getAttribute('aria-disabled') !== String(disabled)) card.setAttribute('aria-disabled',String(disabled));
        if (kind !== 'none') {
          const price = item ? `+ ${this.money.format(item.price/100)}` : kind === 'frame' && sizeOf(variant) === '30x20' ? this.labels.small : this.labels.unavailable;
          this.text(`[data-mount-price="${kind}"]`,price);
          const sku = item?.sku || '';
          if (card.dataset.mountSku !== sku) card.dataset.mountSku = sku;
        }
      }
      const selected = this.accessory(this.choice,variant);
      this.message('[data-mount-summary]',selected ? `${this.labels.surcharge}: + ${this.money.format(selected.price/100)} ${this.labels.each}` : '');
    }
    text(selector,value) {
      const target = this.ui.querySelector(selector);
      if (target && target.textContent !== value) target.textContent = value;
    }
    message(selector,value) {
      const target = this.ui?.querySelector(selector);
      if (!target) return;
      this.text(selector,value);
      if (target.hidden !== !value) target.hidden = !value;
    }
    showError(message) {
      this.message('[data-mount-error]',message);
      this.ui?.scrollIntoView?.({block:'nearest',behavior:'smooth'});
    }
    owns(payload) { return lineItems(payload).some(item => this.variants.has(String(item.id))); }
    snapshot(payload) {
      if (this.choice === 'none') return null;
      const parents = lineItems(payload).filter(item => this.variants.has(String(item.id)));
      const variant = parents.length === 1 ? this.variants.get(String(parents[0].id)) : null;
      if (variant && !isAcrylic(variant)) return null;
      const selected = this.selectedVariant();
      const accessory = this.accessory(this.choice,variant);
      if (!variant || !selected || String(selected.id) !== String(variant.id) || !accessory) {
        this.showError(this.labels.mismatch);
        throw new Error(this.labels.mismatch);
      }
      return { kind:this.choice, variant, accessory:{...accessory}, handle:this.config.accessories[this.choice].handle };
    }
    async attach(payload,selection) {
      const items = lineItems(payload);
      const parents = items.filter(item => String(item.id) === String(selection.variant.id));
      if (parents.length !== 1) throw new Error(this.labels.mismatch);
      const parent = parents[0];
      if (items.some(item => item.properties?._wauzy_mount_group && item.properties._wauzy_mount_sku === selection.accessory.sku)) return payload;
      const quantity = Number(parent.quantity);
      if (!Number.isSafeInteger(quantity) || quantity < 1) throw new Error(this.labels.error);
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(),8000);
      let fresh;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}products/${encodeURIComponent(selection.handle)}.js`,{signal:controller.signal,cache:'no-store',headers:{Accept:'application/json'}});
        if (!response.ok) throw new Error();
        fresh = await response.json();
      } catch { throw new Error(this.labels.error); }
      finally { clearTimeout(timeout); }
      const matches = (fresh.variants || []).filter(item => item.sku === selection.accessory.sku);
      const live = matches.length === 1 ? matches[0] : null;
      if (!live || !live.available || String(live.id) !== String(selection.accessory.id) || !Number.isFinite(live.price) || live.price <= 0) throw new Error(this.labels.error);
      if (live.price !== selection.accessory.price) {
        this.config.accessories[selection.kind].variants = fresh.variants;
        this.sync();
        throw new Error(this.labels.changed);
      }
      const group = crypto.randomUUID();
      const label = selection.kind === 'frame' ? `${this.labels.frame} (${this.labels.floating})` : this.labels.plate;
      const linkedParent = {...parent,properties:{...parent.properties,[this.labels.title]:label,_wauzy_mount_group:group}};
      const child = {id:live.id,quantity,parent_id:parent.id,properties:{_wauzy_mount_group:group,_wauzy_mount_sku:live.sku,_wauzy_mount_parent_variant:String(parent.id),[this.labels.size]:sizeOf(selection.variant).replace('x',' × ')+' cm'}};
      const combined = [...items.map(item => item === parent ? linkedParent : item),child];
      if (Array.isArray(payload)) return combined;
      if (Array.isArray(payload.items)) return {...payload,items:combined};
      const {id,quantity:oldQuantity,properties,...rest} = payload;
      return {...rest,items:combined};
    }
  }
  customElements.define('wauzy-mounting-config',WauzyMounting);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wauzy-bewertungen"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('wauzy-reviews')) {
  customElements.define('wauzy-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.active) return;
      this.active = true;
      this.q = (s) => this.querySelector(s);
      this.t = JSON.parse(this.q('.wr-translations').textContent);
      this.locale = this.dataset.locale || 'de-DE';
      this.customPhotos = [...this.querySelectorAll('.wr-track [data-custom-photo]')].map(element => ({full:this.url(element.dataset.full.replace(/^\/\//,'https://')), alt:element.querySelector('img').alt, element})).filter(photo => photo.full);
      this.countries = ['FR','NL','US'].includes(this.dataset.country) ? [this.dataset.country] : ['DE','AT'];
      this.events = new AbortController();
      const on = (el, event, fn) => el.addEventListener(event, fn, { signal: this.events.signal });
      this.limit = 10;
      this.q('.wr-verified-input').checked = this.dataset.verifiedDefault === 'true';
      on(this.q('.wr-sort'), 'change', () => this.changeView());
      on(this.q('.wr-verified-input'), 'change', () => this.changeView());
      on(this.q('.wr-more'), 'click', () => { this.limit += 10; if (this.storeMode) this.showStore(); else this.render(); });
      on(this.q('.wr-retry'), 'click', () => this.storeMode ? this.showStore() : this.load());
      on(this.q('.wr-write'), 'click', () => this.q('.wr-write-panel').hidden ? this.openReviewForm() : this.closeReviewForm());
      on(this.q('.wr-write-close'), 'click', () => this.closeReviewForm());
      on(this.q('.wr-write-retry'), 'click', () => this.openReviewForm());
      on(this.q('.wr-write-panel'), 'click', e => { if (e.target.closest('.jdgm-cancel-rev')) { e.preventDefault(); this.closeReviewForm(); } });
      on(this.q('.wr-close'), 'click', () => this.q('dialog').close());
      this.querySelectorAll('[data-scroll]').forEach(b => on(b, 'click', () => this.q('.wr-track').scrollBy({left: Number(b.dataset.scroll) * this.q('.wr-track').clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'})));
      this.querySelectorAll('[data-view]').forEach(b => on(b, 'click', () => this.showImage(this.imageIndex + Number(b.dataset.view))));
      on(this.q('dialog'), 'keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); this.showImage(this.imageIndex + (e.key === 'ArrowRight' ? 1 : -1)); } });
      on(this.q('.wr-track'), 'scroll', () => this.updateArrows());
      if (this.dataset.editor === 'true') on(document, 'shopify:block:select', event => {
        const photo = this.q('.wr-track [data-block-id="' + CSS.escape(event.detail.blockId) + '"]');
        if (photo) photo.scrollIntoView({block:'nearest', inline:'start', behavior:'instant'});
      });
      this.observer = new ResizeObserver(() => this.updateArrows());
      this.observer.observe(this.q('.wr-track'));
      this.ratingLinks = [];
      this.tabIndex = -1;
      this.linkRatingBadges(document);
      this.ratingObserver = new MutationObserver(records => records.forEach(record => {
        if (record.type === 'childList') record.addedNodes.forEach(node => this.linkRatingBadges(node));
        else this.prepareRatingLink(record.target.closest('.wr-rating-link'));
      }));
      this.ratingObserver.observe(document.querySelector('main') || document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['role','tabindex']});
      this.load();
    }
    disconnectedCallback() {
      this.active = false;
      this.events?.abort();
      this.request?.abort();
      this.observer?.disconnect();
      this.ratingObserver?.disconnect();
      this.ratingLinks?.forEach(link => { if (link.isConnected) link.replaceWith(...link.childNodes); });
      this.q('dialog').close();
    }
    linkRatingBadges(root) {
      if (![1,9].includes(root.nodeType)) return;
      this.prepareRatingLink(root.closest?.('.wr-rating-link'));
      const selector = '.jdgm-preview-badge[data-id="' + this.dataset.product + '"],.judgeme-preview-badge[data-id="' + this.dataset.product + '"]';
      const badges = [...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector)];
      badges.forEach(badge => {
        if (!badge.isConnected || badge.closest('a')) return;
        const link = this.node('a', 'wr-rating-link');
        link.setAttribute('href', '#' + this.id);
        link.addEventListener('click', event => event.stopPropagation(), {capture:true, signal:this.events.signal});
        badge.before(link);
        link.append(badge);
        this.prepareRatingLink(link);
        this.ratingLinks.push(link);
      });
    }
    prepareRatingLink(link) {
      if (!link || link.getAttribute('href') !== '#' + this.id) return;
      link.querySelectorAll('.jdgm-prev-badge__stars').forEach(stars => {
        if (stars.hasAttribute('tabindex')) stars.removeAttribute('tabindex');
        if (stars.getAttribute('role') !== 'img') stars.setAttribute('role', 'img');
        if (stars.dataset.score) stars.setAttribute('aria-label', stars.dataset.score + ' ' + this.t.out_of);
      });
    }
    node(tag, cls, text) {
      const el = document.createElement(tag);
      if (cls) el.className = cls;
      if (text !== undefined) el.textContent = text;
      return el;
    }
    shortenVariant(value) {
      const characters = typeof Intl.Segmenter === 'function' ? [...new Intl.Segmenter(this.locale, {granularity: 'grapheme'}).segment(value)].map(part => part.segment) : Array.from(value);
      return characters.length > 40 ? characters.slice(0, 40).join('') + '…' : value;
    }
    async waitForForm(check) {
      const deadline = Date.now() + 10000;
      while (!check()) {
        if (!this.isConnected || Date.now() >= deadline) throw new Error('Review form unavailable');
        await new Promise(resolve => setTimeout(resolve, 100));
      }
    }
    async prepareReviewForm() {
      await this.waitForForm(() => window.jdgm?.$ && window.jdgm?.loadScript && window.jdgm?.widgetPath && window.jdgm?.templates);
      const jdgm = window.jdgm;
      jdgm.loadCSS(jdgm.widgetPath('form.css'));
      if (!jdgm._renderAndSetupReviewForm) jdgm.loadScript(jdgm.CDN_HOST + 'widget/form.js');
      await this.waitForForm(() => jdgm._renderAndSetupReviewForm && jdgm._setupFormsSubmit && jdgm.openForm && jdgm.setupReviewFormValidation);
      if (!this.isConnected) return;
      const host = this.node('div', 'jdgm-widget wr-write-widget');
      host.dataset.id = this.dataset.product;
      host.dataset.productTitle = this.dataset.productTitle;
      host.innerHTML = '<div class="jdgm-rev-widg"><div class="jdgm-rev-widg__header"><div class="jdgm-row-stars"></div></div></div>';
      this.q('.wr-write-mount').replaceChildren(host);
      const widget = jdgm.$(host);
      jdgm._renderAndSetupReviewForm(widget);
      jdgm._setupFormsSubmit(widget);
      if (!host.querySelector('.jdgm-form')) throw new Error('Review form missing');
      host.querySelectorAll('.jdgm-form__rating .jdgm-star').forEach(star => { star.title = star.dataset.alt + ' ' + this.t.out_of; star.setAttribute('aria-label', star.title); });
      this.formHost = host;
    }
    async openReviewForm() {
      if (this.formLoading) return;
      const button = this.q('.wr-write');
      const status = this.q('.wr-write-status');
      this.q('.wr-write-panel').hidden = false;
      button.setAttribute('aria-expanded', 'true');
      this.q('.wr-write-retry').hidden = true;
      status.hidden = false;
      status.textContent = this.t.write_loading;
      button.disabled = true;
      this.formLoading = true;
      try {
        if (!this.formHost) await this.prepareReviewForm();
        if (!this.isConnected || this.q('.wr-write-panel').hidden) return;
        status.hidden = true;
        window.jdgm.openForm(window.jdgm.$(this.formHost));
        this.q('.wr-write-panel').scrollIntoView({block:'start', behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      } catch {
        if (!this.isConnected) return;
        status.hidden = false;
        status.textContent = this.t.write_error;
        this.q('.wr-write-retry').hidden = false;
      } finally {
        button.disabled = false;
        this.formLoading = false;
      }
    }
    closeReviewForm() {
      this.q('.wr-write-panel').hidden = true;
      this.q('.wr-write').setAttribute('aria-expanded', 'false');
      this.q('.wr-write').focus({preventScroll:true});
    }
    url(value) {
      try { const url = new URL(value); return url.protocol === 'https:' ? url.href : ''; } catch { return ''; }
    }
    parse(html, store = false) {
      const template = document.createElement('template');
      template.innerHTML = html;
      const doc = template.content;
      const widget = doc.querySelector('.jdgm-review-widget');
      if (!store && widget?.dataset.productId && widget.dataset.productId !== this.dataset.product) throw new Error('Product mismatch');
      const scope = doc.querySelector('.jdgm-rev-widg') || doc;
      const text = (r, selector) => r.querySelector(selector)?.textContent.trim() || '';
      const raw = [...scope.querySelectorAll('.jdgm-rev[data-review-id]')];
      const reviews = raw.map(r => {
        const timestamp = r.querySelector('.jdgm-rev__timestamp');
        const date = timestamp?.getAttribute('datetime') || timestamp?.dataset.content || '';
        const photos = [...r.querySelectorAll('.jdgm-rev__pic-link:not(.jdgm-rev__product-picture)')].map(a => ({full: this.url(a.dataset.mfpSrc || a.getAttribute('href')), thumb: this.url(a.querySelector('img')?.dataset.src || a.querySelector('img')?.getAttribute('src'))})).filter(p => p.full);
        const variant = text(r, '.jdgm-rev__prod-variant-wrapper > span:not(.jdgm-rev__variant-label)').replace(/\s+/g, ' ');
        return { variant: /^default title$/i.test(variant) ? '' : variant, id: r.dataset.reviewId, country: this.reviewCountry(r), pinned: Boolean(r.querySelector('.jdgm-rev__pinned')), productUrl: r.dataset.productUrl || (store ? r.querySelector('.jdgm-rev__prod-link')?.getAttribute('href') || '' : ''), productTitle: text(r, '.jdgm-rev__prod-link'), name: text(r, '.jdgm-rev__author') || this.t.buyer, rating: Number(r.querySelector('.jdgm-rev__rating')?.dataset.score), verified: r.dataset.verifiedBuyer === 'true', date: Date.parse(date.replace(' UTC','Z').replace(' ','T')) || 0, title: text(r, '.jdgm-rev__title'), body: text(r, '.jdgm-rev__body'), reply: text(r, '.jdgm-rev__reply-content'), helpful: Math.max(0, Number(r.dataset.thumbUpCount) || 0), photos };
      }).filter(r => {
        if (!Number.isInteger(r.rating) || r.rating < 1 || r.rating > 5) throw new Error('Invalid review');
        if (store || !r.productUrl) return true;
        try { return decodeURIComponent(new URL(r.productUrl, location.origin).pathname).split('/products/')[1]?.split('/')[0] === this.dataset.handle; } catch { return false; }
      });
      const pagination = scope.querySelector('.jdgm-paginate');
      const pages = [...(pagination?.querySelectorAll('[data-page]') || [])].map(a => Number(a.dataset.page)).filter(Number.isFinite);
      const totalValue = scope.dataset?.numberOfReviews;
      const total = totalValue === undefined ? null : Number(totalValue);
      if (!store && !raw.length && total !== 0 && !doc.querySelector('.jdgm-rev-widg')) throw new Error('Unsupported widget response');
      const header = doc.querySelector('.jdgm-all-reviews__header');
      const stats = header ? {count: Number(header.dataset.numberOfReviews), average: Number(header.dataset.averageRating), productCount: Number(header.dataset.numberOfProductReviews), shopCount: Number(header.dataset.numberOfShopReviews), buckets: Object.fromEntries([...header.querySelectorAll('.jdgm-histogram__row[data-rating]')].map(r => [Number(r.dataset.rating), Number(r.dataset.frequency)]))} : null;
      return {reviews, rawIds: raw.map(r => r.dataset.reviewId), total, stats, last: Math.max(1,...pages)};
    }

    reviewCountry(review) {
      const location = review.querySelector('.jdgm-rev__location')?.textContent || '';
      const country = location.replace(/[()]/g, '').split(',').pop().trim().toLowerCase();
      const countries = {de:'DE', germany:'DE', deutschland:'DE', allemagne:'DE', duitsland:'DE', at:'AT', austria:'AT', österreich:'AT', autriche:'AT', oostenrijk:'AT', fr:'FR', france:'FR', frankreich:'FR', frankrijk:'FR', nl:'NL', netherlands:'NL', 'the netherlands':'NL', nederland:'NL', niederlande:'NL', 'pays-bas':'NL', us:'US', usa:'US', 'united states':'US', 'united states of america':'US', 'vereinigte staaten':'US', 'états-unis':'US', 'verenigde staten':'US'};
      return countries[country] || '';
    }
    marketMatch(review) {
      return this.countries.includes(review.country);
    }
    defaultSort() {
      return this.reviews.some(r => r.pinned) ? 'featured' : this.reviews.some(r => r.photos.length) ? 'photos_first' : 'newest';
    }
    compare(a, b, sort) {
      if (sort === 'featured' && (a.pinned || b.pinned)) return Number(b.pinned) - Number(a.pinned);
      if (sort === 'featured' || sort === 'photos_first') return Number(Boolean(b.photos.length)) - Number(Boolean(a.photos.length)) || b.date - a.date;
      if (sort === 'oldest') return a.date - b.date;
      if (sort === 'helpful') return b.helpful - a.helpful || b.date - a.date;
      return b.date - a.date;
    }
    changeView() {
      this.storeDefaultPending = false;
      this.limit = 10;
      if (this.storeMode) this.showStore(); else this.render();
    }
    busy(value) {
      this.q('.wr-sort').disabled = value;
      this.q('.wr-verified-input').disabled = value;
      this.q('.wr-more').disabled = value;
      if (value) this.q('.wr-more').textContent = this.t.loading;
      this.q('.wr-list').setAttribute('aria-busy', String(value));
    }
    async pageData(endpoint, params, controller) {
      const url = new URL('https://judge.me/api/v1/widgets/' + endpoint);
      url.search = new URLSearchParams({shop_domain: this.dataset.shop, api_token: this.dataset.token, ...params});
      const cache = this.constructor.pageCache ||= new Map();
      const cached = cache.get(url.href);
      if (cached && Date.now() - cached.time < 300000) return cached.data;
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(url, {signal: controller.signal, credentials: 'omit', referrerPolicy: 'no-referrer'});
        if (!response.ok) throw new Error('Request failed');
        const data = await response.json();
        if (data.error) throw new Error('Unsupported response');
        cache.set(url.href, {time: Date.now(), data});
        if (cache.size > 24) cache.delete(cache.keys().next().value);
        return data;
      } finally { clearTimeout(timeout); }
    }
    async storePage(stream, sort, controller) {
      const sortBy = {featured: 'pictures_first', photos_first: 'pictures_first', photos: 'with_pictures', helpful: 'most_helpful', newest: 'created_at', oldest: 'created_at'}[sort] || 'created_at';
      const data = await this.pageData('all_reviews_page', {page: String(stream.page), review_type: stream.type, sort_by: sortBy, sort_dir: sort === 'oldest' ? 'asc' : 'desc'}, controller);
      if (typeof data.all_reviews !== 'string' || typeof data.all_reviews_header !== 'string') throw new Error('Unsupported store response');
      const result = this.parse(data.all_reviews_header + data.all_reviews, true);
      if (!result.stats || !Number.isFinite(result.stats.count) || result.stats.count < 0) throw new Error('Missing store totals');
      if (!this.isConnected || this.request !== controller) return;
      this.storeStats = result.stats;
      let added = 0;
      result.reviews.forEach(r => { if (!stream.records.has(r.id)) { stream.records.set(r.id, r); added++; } });
      const total = stream.type === 'product-reviews' ? result.stats.productCount : result.stats.shopCount;
      stream.hasMore = added > 0 && stream.records.size < total;
      stream.boundary = result.reviews.at(-1);
      stream.page++;
      if (stream.page > 1000 && stream.hasMore) throw new Error('Pagination limit');
    }
    async showStore(chooseDefault = false) {
      this.request?.abort();
      const controller = new AbortController();
      this.request = controller;
      const status = this.q('.wr-status');
      status.hidden = false;
      status.textContent = this.t.loading;
      this.q('.wr-retry').hidden = true;
      this.busy(true);
      try {
        if (chooseDefault) {
          this.q('.wr-sort').value = 'photos_first';
          this.storeDefaultPending = true;
        }
        const sort = this.q('.wr-sort').value;
        let streams = this.storeViews.get(sort);
        if (!streams) {
          streams = ['product-reviews', 'shop-reviews'].map(type => ({type, page: 1, records: new Map(), hasMore: true}));
          this.storeViews.set(sort, streams);
        }
        const matches = r => this.marketMatch(r) && (!this.q('.wr-verified-input').checked || r.verified) && (sort !== 'photos' || r.photos.length > 0);
        await Promise.all(streams.map(async stream => {
          let pagesLoaded = 0;
          while (stream.hasMore && [...stream.records.values()].filter(matches).length <= this.limit && pagesLoaded < 3) {
            await this.storePage(stream, sort, controller);
            pagesLoaded++;
            if (!this.isConnected || this.request !== controller) return;
          }
        }));
        if (!this.isConnected || this.request !== controller) return;
        const records = new Map();
        streams.forEach(stream => stream.records.forEach((r,id) => records.set(id,r)));
        const boundaries = streams.filter(stream => stream.hasMore && [...stream.records.values()].filter(matches).length <= this.limit).map(stream => stream.boundary).filter(Boolean);
        this.reviews = [...records.values()].filter(r => this.marketMatch(r) && boundaries.every(boundary => this.compare(r, boundary, sort) <= 0));
        this.storeHasMore = streams.some(stream => stream.hasMore);
        if (this.storeDefaultPending && (this.reviews.length || !this.storeHasMore)) {
          this.storeDefaultPending = false;
          const selected = this.defaultSort();
          this.q('.wr-sort').value = selected;
          this.storeViews.set(selected, streams);
        }
        this.q('option[value="featured"]').disabled = !this.reviews.some(r => r.pinned);
        this.buildSummary();
        this.buildGallery();
        this.render();
        this.q('.wr-content').hidden = false;
        status.hidden = true;
        this.updateArrows();
      } catch {
        if (!this.isConnected || this.request !== controller) return;
        status.textContent = this.t.error;
        this.q('.wr-retry').hidden = false;
      } finally {
        if (this.request === controller) this.busy(false);
      }
    }
    async productPage(page, controller) {
      const url = new URL('https://judge.me/api/v1/widgets/product_review');
      url.search = new URLSearchParams({shop_domain:this.dataset.shop, api_token:this.dataset.token, external_id:this.dataset.product, page:String(page), per_page:'100'});
      const timeout = setTimeout(() => controller.abort(), 30000);
      let data;
      try {
        const response = await fetch(url, {signal:controller.signal, credentials:'omit', referrerPolicy:'no-referrer'});
        if (!response.ok) throw new Error('Request failed');
        data = await response.json();
      } finally { clearTimeout(timeout); }
      if (typeof data.widget !== 'string' || data.error) throw new Error('Unsupported response');
      if (data.product_external_id != null && String(data.product_external_id) !== this.dataset.product) throw new Error('Product mismatch');
      return this.parse(data.widget);
    }
    async productReviews(controller) {
      const batch = new AbortController();
      controller.signal.addEventListener('abort', () => batch.abort(), {once:true, signal:batch.signal});
      if (controller.signal.aborted) batch.abort();
      const records = new Map();
      const seen = new Set();
      const pending = new Map();
      let page = 1;
      let nextPage = 2;
      try {
        let result = await this.productPage(page, batch);
        while (true) {
          if (batch.signal.aborted || !this.isConnected || this.request !== controller) throw new DOMException('Aborted', 'AbortError');
          let added = 0;
          result.rawIds.forEach(id => { if (!seen.has(id)) { seen.add(id); added++; } });
          result.reviews.forEach(r => records.set(r.id, r));
          if (!result.rawIds.length || !added) return [...records.values()];
          if (page >= 1000) throw new Error('Pagination limit');
          while (pending.size < 3 && nextPage <= 1000) {
            const index = nextPage++;
            pending.set(index, this.productPage(index, batch).then(result => ({result}), error => ({error})));
          }
          page++;
          const response = await pending.get(page);
          pending.delete(page);
          if (response.error) throw response.error;
          result = response.result;
        }
      } finally { batch.abort(); }
    }
    async load() {
      this.request?.abort();
      const controller = new AbortController();
      this.request = controller;
      const status = this.q('.wr-status');
      status.hidden = false;
      status.textContent = this.t.loading;
      const showCustom = this.dataset.gallery === 'true' && this.customPhotos.length > 0;
      this.classList.toggle('wr-custom-only', showCustom);
      this.q('.wr-content').hidden = !showCustom;
      if (showCustom) this.buildGallery(false);
      this.storeMode = false;
      this.storeStats = null;
      this.q('.wr-retry').hidden = true;
      if (!this.dataset.token || !/^\d+$/.test(this.dataset.product)) {
        status.textContent = this.dataset.editor === 'true' ? this.t.setup : this.t.error;
        return;
      }
      try {
        const reviews = await this.productReviews(controller);
        if (!this.isConnected || this.request !== controller) return;
        this.reviews = reviews.filter(r => this.marketMatch(r));
        if (!this.reviews.length) {
          this.storeMode = true;
          this.storeViews = new Map();
          this.limit = 10;
          await this.showStore(true);
          return;
        }
        this.limit = 10;
        this.q('.wr-sort').value = this.defaultSort();
        this.q('option[value="featured"]').disabled = !this.reviews.some(r => r.pinned);
        this.buildSummary();
        this.buildGallery();
        this.render();
        status.hidden = true;
        this.q('.wr-content').hidden = false;
        this.updateArrows();
      } catch {
        if (!this.isConnected || this.request !== controller) return;
        status.textContent = this.t.error;
        this.q('.wr-retry').hidden = false;
      }
    }
    buildSummary() {
      this.classList.remove('wr-custom-only');
      const count = this.storeStats ? this.storeStats.count : this.reviews.length;
      const average = this.storeStats ? this.storeStats.average : count ? this.reviews.reduce((sum,r) => sum+r.rating, 0)/count : 0;
      this.q('.wr-number').textContent = count ? average.toLocaleString(this.locale, {minimumFractionDigits:1,maximumFractionDigits:1}) : '–';
      this.q('.wr-count').textContent = `${count.toLocaleString(this.locale)} ${this.t.count}`;
      this.q('.wr-average-stars').replaceChildren(document.createTextNode('★★★★★'));
      const fill = this.node('span','wr-star-fill','★★★★★'); fill.style.width = `${average / 5 * 100}%`;
      this.q('.wr-average-stars').append(fill);
      this.q('.wr-total').setAttribute('aria-label', `${average.toFixed(1)} ${this.t.out_of}, ${count} ${this.t.count}`);
      this.q('.wr-bars').replaceChildren();
      for (let rating=5;rating>=1;rating--) {
        const n = this.storeStats ? (this.storeStats.buckets[rating] || 0) : this.reviews.filter(r=>r.rating===rating).length;
        const row = this.node('div','wr-bar-row');
        const bar = this.node('div','wr-track-bar'); const inner = this.node('div','wr-fill'); inner.style.width = `${count ? n/count*100 : 0}%`; bar.append(inner);
        row.append(this.node('span','',`${rating} ★`),bar,this.node('span','',String(n)));
        this.q('.wr-bars').append(row);
      }
    }
    thumbnail(photo) {
      const button = photo.element ? photo.element.cloneNode(true) : this.node('button','wr-thumb');
      button.type='button';
      if (!photo.element) {
        button.setAttribute('aria-label',this.t.photo);
        const img = this.node('img'); img.src=photo.thumb || photo.full; img.alt=''; img.loading='lazy'; img.decoding='async'; img.width=200; img.height=200;
        button.append(img);
      }
      button.addEventListener('click',()=>{this.showImage(this.photos.findIndex(p=>p.full===photo.full));this.q('dialog').showModal();});
      return button;
    }
    buildGallery(includeReviews = true) {
      const unique = new Map();
      this.customPhotos.forEach(p=>{if(!unique.has(p.full))unique.set(p.full,p);});
      if (includeReviews) [...(this.reviews || [])].sort((a,b)=>b.date-a.date).forEach(r=>r.photos.forEach(p=>{if(!unique.has(p.full))unique.set(p.full,p);}));
      this.photos=[...unique.values()];
      const track=this.q('.wr-track');track.replaceChildren();
      this.q('.wr-gallery').hidden=!this.photos.length || this.dataset.gallery!=='true';
      if (this.dataset.gallery==='true') this.photos.forEach(p=>track.append(this.thumbnail(p)));
    }
    updateArrows() {
      const track=this.q('.wr-track');
      this.q('.wr-gallery-nav').hidden=track.scrollWidth<=track.clientWidth+2;
      this.q('[data-scroll="-1"]').disabled=track.scrollLeft<=1;
      this.q('[data-scroll="1"]').disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;
    }
    showImage(index) {
      if (!this.photos?.length) return;
      this.imageIndex=(index+this.photos.length)%this.photos.length;
      const img=this.node('img');img.src=this.photos[this.imageIndex].full;img.alt=this.photos[this.imageIndex].alt || this.t.photos;
      this.q('.wr-large').replaceChildren(img);
      this.q('.wr-image-count').textContent=`${this.imageIndex+1} / ${this.photos.length}`;
      this.querySelectorAll('[data-view]').forEach(b=>b.disabled=this.photos.length<2);
    }
    render() {
      if (!this.reviews) return;
      let rows=this.reviews.filter(r=>!this.q('.wr-verified-input').checked || r.verified);
      const sort=this.q('.wr-sort').value;
      if(sort==='photos')rows=rows.filter(r=>r.photos.length);
      rows.sort((a,b) => this.compare(a,b,sort));
      const list=this.q('.wr-list');list.replaceChildren();
      if(!rows.length && !(this.storeMode && this.storeHasMore)) list.append(this.node('p','wr-empty',this.reviews.length?this.t.no_match:this.t.empty));
      rows.slice(0,this.limit).forEach(r=>{
        const article=this.node('article','wr-review');
        const head=this.node('div','wr-review-head');
        const parts=r.name.trim().split(/\s+/); const initials=Array.from(parts[0])[0]+(parts.length>1?Array.from(parts[parts.length-1])[0]:'');
        const avatar=this.node('span','wr-avatar',initials.toLocaleUpperCase());avatar.setAttribute('aria-hidden','true');
        const person=this.node('div','wr-person');person.append(this.node('span','wr-name',r.name));
        if(r.verified)person.append(this.node('span','wr-verified',`✓ ${this.t.verified}`));
        const meta=this.node('div','wr-meta');const stars=this.node('div','wr-stars','★'.repeat(r.rating)+'☆'.repeat(5-r.rating));stars.setAttribute('aria-label',`${r.rating} ${this.t.out_of}`);meta.append(stars);
        if(r.date){const date=this.node('time','',new Date(r.date).toLocaleDateString(this.locale,{day:'numeric',month:'short',year:'numeric'}));date.dateTime=new Date(r.date).toISOString();meta.append(date);}
        head.append(avatar,person,meta);article.append(head);
        if (this.storeMode && r.productTitle) article.append(this.node('span', 'wr-product', r.productTitle));
        if(r.title)article.append(this.node('h3','wr-review-title',r.title));
        article.append(this.node('p','wr-body',r.body));
        if(r.photos.length || r.variant){
          const media=this.node('div','wr-review-media');
          if(r.photos.length){const photos=this.node('div','wr-review-photos');r.photos.forEach(p=>photos.append(this.thumbnail(p)));media.append(photos);}
          if(r.variant){const variant=this.node('span','wr-variant',this.shortenVariant(r.variant));variant.title=this.t.variant+': '+r.variant;variant.setAttribute('aria-label',variant.title);media.append(variant);}
          article.append(media);
        }
        if(r.helpful)article.append(this.node('p','wr-helpful',`${r.helpful} ${this.t.helpful_count}`));
        if(r.reply){const reply=this.node('div','wr-reply');reply.append(this.node('strong','',this.t.reply),this.node('p','wr-body',r.reply));article.append(reply);}
        list.append(article);
      });
      const more = rows.length > this.limit || (this.storeMode && this.storeHasMore);
      this.q('.wr-more').textContent = this.storeMode && this.storeHasMore && rows.length <= this.limit ? (rows.length ? this.t.more_search : this.t.search_market) : this.t.more;
      this.q('.wr-more').hidden = !more;
      this.q('.wr-footer').hidden = !more;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wauzy-konfigurator"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wauzy-konfigurator-labels')) {
  customElements.define('wauzy-konfigurator-labels', class extends HTMLElement {
    connectedCallback() {
      this.originalLabels = new Map();
      this.badges = new Map();
      this.dropdownImages = new Map();
      this.imageLabels = new Set();
      this.infoItems = new Map();
      this.materialLinks = new Map();
      this.blockedInputs = new Map();
      this.onVariantChange = () => this.schedule();
      this.onUnavailableClick = (event) => {
        const tile = event.target.closest?.('.wz-unavailable');
        if (!tile?.closest('#tee-artwork-form')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      };
      document.addEventListener('change', this.onVariantChange);
      document.addEventListener('click', this.onUnavailableClick, true);
      this.imageObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.loadLabelImage(entry.target);
          this.imageObserver.unobserve(entry.target);
        });
      }, { rootMargin: '300px 0px' }) : null;
      this.observer = new MutationObserver((mutations) => {
        const relevant = mutations.some((mutation) => {
          const target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
          if (mutation.type === 'attributes' && ['class', 'src', 'data-src', 'aria-selected'].includes(mutation.attributeName) && !target?.closest('.tee-custom-select, .tee-radio, .tee-option')) return false;
          if (target?.closest('#tee-artwork-form, wauzy-konfigurator-labels')) return true;
          return [...mutation.addedNodes, ...mutation.removedNodes].some((node) =>
            node.nodeType === 1 && (node.matches('#tee-artwork-form') || node.querySelector('#tee-artwork-form'))
          );
        });
        if (relevant) this.schedule();
      });
      this.observe();
      this.schedule();
    }

    observe() {
      this.observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class', 'src', 'data-src', 'aria-selected', 'title', 'for', 'data-wz-type', 'data-wz-value', 'data-wz-label', 'data-wz-bestseller', 'data-wz-badge-text', 'data-wz-image', 'data-wz-position', 'disabled', 'aria-disabled', 'data-wz-target', 'data-wz-heading', 'data-wz-field-id']
      });
    }

    schedule() {
      if (this.pendingFrame) return;
      this.pendingFrame = requestAnimationFrame(() => {
        this.pendingFrame = null;
        if (this.isConnected) this.applyLabels();
      });
    }

    restore(span, saved) {
      if (span.textContent === saved.applied) span.textContent = saved.original;
      this.originalLabels.delete(span);
    }

    loadLabelImage(label) {
      const image = label.dataset.wzLazyImage;
      if (!image) return;
      label.style.setProperty('--wz-img', `url(${JSON.stringify(image)})`);
      label.style.setProperty('--wz-position', label.dataset.wzLazyPosition || 'center');
      label.dataset.wzImageLoaded = image;
    }

    restoreAvailability(input, saved) {
      input.disabled = saved.disabled;
      if (saved.aria === null) input.removeAttribute('aria-disabled');
      else input.setAttribute('aria-disabled', saved.aria);
      input.closest('.tee-radio')?.classList.remove('wz-unavailable');
      this.blockedInputs.delete(input);
    }

    syncAvailability(form) {
      const variants = Object.values(window.teeinblueCampaign?.variantsById || {});
      const materialLabel = form?.querySelector('#tee-field--teeinblue-available-prod .active label > span');
      const materialName = (this.originalLabels.get(materialLabel)?.original || materialLabel?.textContent || '').trim();
      const sizeInput = form?.querySelector('.tee-option--size .tee-radio.active input');
      const size = sizeInput?.value;
      const materialVariants = variants.filter((variant) => variant.option1 === materialName);
      const active = new Set();
      if (materialVariants.length && size && materialVariants.some((variant) => variant.option3 === size)) {
        form.querySelectorAll('.tee-option--color .tee-radio input[type="radio"]').forEach((input) => {
          const available = materialVariants.some((variant) => variant.option2 === input.value && variant.option3 === size && variant.available);
          if (available) return;
          active.add(input);
          if (!this.blockedInputs.has(input)) this.blockedInputs.set(input, { disabled: input.disabled, aria: input.getAttribute('aria-disabled') });
          input.disabled = true;
          input.setAttribute('aria-disabled', 'true');
          input.closest('.tee-radio').classList.add('wz-unavailable');
        });
      }
      this.blockedInputs.forEach((saved, input) => {
        if (!active.has(input)) this.restoreAvailability(input, saved);
      });
    }

    syncMaterialLinks(form) {
      const row = form?.querySelector('#tee-field--teeinblue-available-prod .tee-row');
      const active = new Set();
      const items = [];
      if (row) this.querySelectorAll('template[data-wz-material-link]').forEach((template) => {
        const key = template.dataset.wzMaterialLink;
        let item = this.materialLinks.get(key);
        if (!item || item.html !== template.innerHTML) {
          item?.element.remove();
          this.materialLinks.delete(key);
          const element = template.content.firstElementChild?.cloneNode(true);
          const link = element?.querySelector('a.wz-material-link');
          if (!link || !link.textContent.trim() || !link.getAttribute('href')?.trim()) return;
          const image = link.dataset.wzLinkImage;
          if (image) {
            link.style.setProperty('--wz-img', 'url(' + JSON.stringify(image) + ')');
            link.style.setProperty('--wz-position', link.dataset.wzLinkPosition || 'center');
          }
          item = { element, html: template.innerHTML };
          this.materialLinks.set(key, item);
        }
        active.add(key);
        items.push(item.element);
      });
      this.materialLinks.forEach((item, key) => {
        if (active.has(key)) return;
        item.element.remove();
        this.materialLinks.delete(key);
      });
      let next = null;
      for (let index = items.length - 1; index >= 0; index--) {
        const element = items[index];
        if (element.parentElement !== row || element.nextSibling !== next) row.insertBefore(element, next);
        next = element;
      }
    }

    syncInfo(form) {
      const active = new Set();
      const clean = (value) => value.replace(/\*/g, '').replace(/\s+/g, ' ').trim().toLocaleLowerCase();
      this.querySelectorAll('template[data-wz-info]').forEach((template) => {
        if (!template.innerHTML.trim() || !form) return;
        let heading;
        const target = template.dataset.wzTarget;
        if (target === 'material') heading = form.querySelector('#tee-field--teeinblue-available-prod')?.closest('.tee-option')?.querySelector('.tee-option__title');
        if (target === 'frame') heading = form.querySelector('.tee-option--color > .tee-option__title');
        if (target === 'size') heading = form.querySelector('.tee-option--size > .tee-option__title');
        if (target === 'custom') {
          const id = template.dataset.wzFieldId;
          if (id) {
            const field = document.getElementById(id);
            if (field && form.contains(field)) heading = field.querySelector('.tee-field__heading, .tee-option__title');
          } else {
            heading = [...form.querySelectorAll('.tee-option__title, .tee-field__heading')].find((element) => {
              const clone = element.cloneNode(true);
              clone.querySelectorAll('.wz-info-button, .tee-asterisk').forEach((node) => node.remove());
              return clean(clone.textContent) === clean(template.dataset.wzHeading || '');
            });
          }
        }
        if (!heading) return;
        const key = template.dataset.wzInfo;
        active.add(key);
        let item = this.infoItems.get(key);
        if (!item || item.heading !== heading) {
          item?.button.remove();
          item?.panel.remove();
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'wz-info-button';
          button.setAttribute('aria-label', heading.textContent.trim());
          button.setAttribute('aria-expanded', 'false');
          button.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5"/><path d="M12 10.5v6M12 7.5v.1" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
          const panel = document.createElement('div');
          panel.className = 'wz-info-panel';
          panel.id = 'wz-info-' + key;
          panel.setAttribute('popover', 'auto');
          panel.setAttribute('role', 'region');
          panel.setAttribute('aria-label', heading.textContent.trim());
          button.setAttribute('aria-controls', panel.id);
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            if (panel.matches(':popover-open')) { panel.hidePopover(); return; }
            panel.showPopover();
            const rect = button.getBoundingClientRect();
            const width = panel.offsetWidth;
            const height = panel.offsetHeight;
            panel.style.left = Math.max(12, Math.min(rect.left, window.innerWidth - width - 12)) + 'px';
            panel.style.top = Math.max(12, Math.min(rect.bottom + 8, window.innerHeight - height - 12)) + 'px';
          });
          panel.addEventListener('toggle', () => button.setAttribute('aria-expanded', String(panel.matches(':popover-open'))));
          heading.append(button);
          document.body.append(panel);
          item = { heading, button, panel, html: null };
          this.infoItems.set(key, item);
        }
        if (item.html !== template.innerHTML) {
          item.panel.replaceChildren(template.content.cloneNode(true));
          item.html = template.innerHTML;
        }
      });
      this.infoItems.forEach((item, key) => {
        if (active.has(key)) return;
        item.button.remove();
        item.panel.remove();
        this.infoItems.delete(key);
      });
    }

    syncDropdownImages(form) {
      const active = new Set();
      form?.querySelectorAll('.tee-custom-select').forEach((select) => {
        const input = select.querySelector(':scope > .tee-custom-select__input');
        const current = input?.querySelector('.tee-custom-select__current');
        const selected = select.querySelector('.tee-custom-select-item.tee-active, .tee-custom-select-item[aria-selected="true"]');
        const source = selected?.querySelector('.tee-custom-select-item__thumbnail img');
        const url = source?.getAttribute('data-src') || source?.getAttribute('src');
        if (!input || !current || !url || current.querySelector('img')) return;
        let image = this.dropdownImages.get(input);
        if (!image || image.parentElement !== input) {
          image?.remove();
          image = document.createElement('img');
          image.className = 'wauzy-dropdown-thumbnail';
          image.alt = '';
          image.width = 36;
          image.height = 36;
          input.insertBefore(image, current);
          this.dropdownImages.set(input, image);
        }
        if (image.getAttribute('src') !== url) image.setAttribute('src', url);
        active.add(input);
      });
      this.dropdownImages.forEach((image, input) => {
        if (!active.has(input)) {
          image.remove();
          this.dropdownImages.delete(input);
        }
      });
    }

    syncOptionBadges(form, activeBadges) {
      if (!form) return;
      const clean = (value) => (value || '').replace(/\*/g, '').replace(/\s+/g, ' ').trim().toLocaleLowerCase();
      const text = (element) => {
        const clone = element.cloneNode(true);
        clone.querySelectorAll('.wauzy-konfigurator-badge, .wz-info-button, .tee-asterisk, .tee-clipart-checkmark').forEach((node) => node.remove());
        return clean(clone.textContent);
      };
      this.querySelectorAll('[data-wz-option-badge]').forEach((block) => {
        if (block.dataset.wzBestseller !== 'true' || !block.dataset.wzValue.trim()) return;
        let field;
        const target = block.dataset.wzTarget;
        if (target === 'size') field = form.querySelector('.tee-option--size');
        if (target === 'frame') field = form.querySelector('.tee-option--color');
        if (target === 'material') field = form.querySelector('#tee-field--teeinblue-available-prod');
        if (target === 'custom') {
          if (block.dataset.wzFieldId) field = document.getElementById(block.dataset.wzFieldId);
          else {
            const heading = [...form.querySelectorAll('.tee-option__title, .tee-field__heading')].find((item) => text(item) === clean(block.dataset.wzHeading));
            field = heading?.closest('.tee-field, .tee-option');
          }
        }
        if (!field || !form.contains(field)) return;
        const value = clean(block.dataset.wzValue);
        field.querySelectorAll('.tee-radio label, .tee-custom-select-item, .tee-custom-select__current').forEach((label) => {
          const input = label.closest('.tee-radio')?.querySelector('input');
          const span = label.querySelector(':scope > span');
          const values = [input?.value, label.getAttribute('title'), text(label), span && text(span), this.originalLabels.get(span)?.original];
          if (!values.some((item) => item && clean(item) === value)) return;
          let badge = this.badges.get(label);
          if (!badge || badge.parentElement !== label) {
            badge?.remove();
            badge = document.createElement('small');
            badge.className = 'wauzy-konfigurator-badge';
            label.append(badge);
            this.badges.set(label, badge);
          }
          const imageTile = label.matches('.tee-radio-label') && label.closest('#tee-field--teeinblue-available-prod, .tee-option--color');
          badge.classList.toggle('wz-option-badge', !imageTile);
          if (badge.textContent !== this.dataset.wzBadgeText) badge.textContent = this.dataset.wzBadgeText;
          activeBadges.add(label);
        });
      });
    }

    applyLabels() {
      this.observer.disconnect();
      try {
        const names = { material: new Map(), frame: new Map() };
        this.querySelectorAll('[data-wz-label]').forEach((block) => {
          const value = block.dataset.wzValue.trim();
          const title = block.dataset.wzLabel.trim();
          if (value) names[block.dataset.wzType]?.set(value, {
            title,
            bestseller: block.dataset.wzBestseller === 'true',
            image: block.dataset.wzImage?.trim() || '',
            position: block.dataset.wzPosition?.trim() || 'center'
          });
        });
        const active = new Set();
        const activeBadges = new Set();
        const activeImages = new Set();
        const form = document.querySelector('#tee-artwork-form');
        const activeMaterialLabel = form?.querySelector('#tee-field--teeinblue-available-prod .active label');
        const activeMaterialValue = activeMaterialLabel?.htmlFor?.replace(/^teeinblue-available-prod-/, '');
        const activeMaterialImage = names.material.get(activeMaterialValue);
        this.syncDropdownImages(form);
        this.syncAvailability(form);
        this.syncInfo(form);
        this.syncMaterialLinks(form);
        form?.querySelectorAll('#tee-field--teeinblue-available-prod label, .tee-option--color label').forEach((label) => {
          const material = label.closest('#tee-field--teeinblue-available-prod');
          const value = material ? label.htmlFor.replace(/^teeinblue-available-prod-/, '') : label.getAttribute('title');
          const config = names[material ? 'material' : 'frame'].get(value);
          const imageConfig = !material && value === 'Ohne' ? (activeMaterialImage || config) : config;
          const image = imageConfig?.image || '';
          if (image) {
            activeImages.add(label);
            if (label.dataset.wzLazyImage !== image) {
              this.imageObserver?.unobserve(label);
              label.dataset.wzLazyImage = image;
              label.dataset.wzLazyPosition = imageConfig.position || 'center';
              delete label.dataset.wzImageLoaded;
              label.style.removeProperty('--wz-img');
              label.style.removeProperty('--wz-position');
            }
            if (label.dataset.wzImageLoaded !== image) {
              if (this.imageObserver) this.imageObserver.observe(label);
              else this.loadLabelImage(label);
            }
            this.imageLabels.add(label);
          }
          if (config?.bestseller) {
            let badge = this.badges.get(label);
            if (!badge || badge.parentElement !== label) {
              badge?.remove();
              badge = document.createElement('small');
              badge.className = 'wauzy-konfigurator-badge';
              label.append(badge);
              this.badges.set(label, badge);
            }
            if (badge.textContent !== this.dataset.wzBadgeText) badge.textContent = this.dataset.wzBadgeText;
            activeBadges.add(label);
          }
          const title = config?.title;
          const span = label.querySelector(':scope > span');
          if (!span || !title) return;
          active.add(span);
          let saved = this.originalLabels.get(span);
          if (!saved) {
            saved = { original: span.textContent, applied: title };
            this.originalLabels.set(span, saved);
          } else if (span.textContent !== saved.applied) {
            saved.original = span.textContent;
          }
          saved.applied = title;
          if (span.textContent !== title) span.textContent = title;
        });
        this.originalLabels.forEach((saved, span) => {
          if (!active.has(span)) this.restore(span, saved);
        });
        this.syncOptionBadges(form, activeBadges);
        this.badges.forEach((badge, label) => {
          if (!activeBadges.has(label)) {
            badge.remove();
            this.badges.delete(label);
          }
        });
        this.imageLabels.forEach((label) => {
          if (activeImages.has(label)) return;
          this.imageObserver?.unobserve(label);
          label.style.removeProperty('--wz-img');
          label.style.removeProperty('--wz-position');
          delete label.dataset.wzLazyImage;
          delete label.dataset.wzLazyPosition;
          delete label.dataset.wzImageLoaded;
          this.imageLabels.delete(label);
        });
      } finally {
        if (this.isConnected) this.observe();
      }
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onVariantChange);
      document.removeEventListener('click', this.onUnavailableClick, true);
      this.blockedInputs?.forEach((saved, input) => this.restoreAvailability(input, saved));
      this.blockedInputs?.clear();
      this.infoItems?.forEach((item) => { item.button.remove(); item.panel.remove(); });
      this.infoItems?.clear();
      this.materialLinks?.forEach((item) => item.element.remove());
      this.materialLinks?.clear();
      this.observer?.disconnect();
      cancelAnimationFrame(this.pendingFrame);
      this.pendingFrame = null;
      this.originalLabels?.forEach((saved, span) => this.restore(span, saved));
      this.badges?.forEach((badge) => badge.remove());
      this.badges?.clear();
      this.dropdownImages?.forEach((image) => image.remove());
      this.dropdownImages?.clear();
      this.imageObserver?.disconnect();
      this.imageLabels?.forEach((label) => {
        label.style.removeProperty('--wz-img');
        label.style.removeProperty('--wz-position');
        delete label.dataset.wzLazyImage;
        delete label.dataset.wzLazyPosition;
        delete label.dataset.wzImageLoaded;
      });
      this.imageLabels?.clear();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wauzy-tee-translations"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wauzy-tee-translations')) {
  customElements.define('wauzy-tee-translations', class extends HTMLElement {
    connectedCallback() {
      const rawRules = Array.from(this.querySelectorAll('[data-active="true"]')).map(element => element.textContent).join("\n");
      const selector = [
        '#tee-artwork-form .tee-available-products .tee-option__title',
        '#tee-artwork-form .tee-available-products .tee-radio-label',
        '#tee-artwork-form .tee-variants .tee-option__title',
        '#tee-artwork-form .tee-variants .tee-radio-label'
      ].join(',');
      const ignored = 'script, style, svg, textarea, input, [contenteditable], [data-variant-badge], .wauzy-konfigurator-badge';
      const normalize = text => text.replace(/\s+/g, ' ').trim().toLowerCase();
      const rules = new Map();

      rawRules.split(/\r?\n/).forEach(line => {
        const separator = line.indexOf('=>');
        if (separator < 0) return;
        const source = normalize(line.slice(0, separator));
        const translation = line.slice(separator + 2).trim();
        if (source && translation) rules.set(source, translation);
      });

      if (window.wauzyTeeTranslations) window.wauzyTeeTranslations.destroy();

      if (!rawRules.trim()) return;
      const changes = new Map();
      const owner = this;
      let scheduled = false;
      let stopped = false;

      function rewrite(node) {
        if (!node) return;
        const current = node.nodeValue;
        const previous = changes.get(node);
        const source = previous && current === previous.result ? previous.source : current;
        const translation = rules.get(normalize(source));
        if (translation === undefined) {
          changes.delete(node);
          return;
        }
        const result = source.match(/^\s*/)[0] + translation + source.match(/\s*$/)[0];
        if (result !== current) node.nodeValue = result;
        changes.set(node, { source, result });
      }

      function observe() {
        observer.observe(document.documentElement, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['title', 'aria-label']
        });
      }

      function apply() {
        if (stopped) return;
        if (owner && !owner.isConnected) {
          destroy();
          return;
        }
        observer.disconnect();
        try {
          for (const node of changes.keys()) {
            const element = node.nodeType === Node.ATTRIBUTE_NODE ? node.ownerElement : node.parentElement;
            if (!element || !element.isConnected) changes.delete(node);
          }
          document.querySelectorAll(selector).forEach(element => {
            const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
            let node;
            while ((node = walker.nextNode())) {
              if (!node.parentElement.closest(ignored)) rewrite(node);
            }
            if (!element.matches('.tee-radio-label')) rewrite(element.getAttributeNode('title'));
            rewrite(element.getAttributeNode('aria-label'));
          });
        } finally {
          if (!stopped) observe();
        }
      }

      function schedule() {
        if (scheduled || stopped) return;
        scheduled = true;
        requestAnimationFrame(() => {
          scheduled = false;
          apply();
        });
      }

      function relevant(node) {
        const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
        return element && (element.closest(selector) || element.querySelector(selector));
      }

      const observer = new MutationObserver(records => {
        if (owner && !owner.isConnected) {
          destroy();
          return;
        }
        if (records.some(record => record.type === 'childList'
          ? (record.target.nodeType === Node.ELEMENT_NODE && record.target.closest(selector)) || Array.from(record.addedNodes).some(relevant)
          : relevant(record.target))) schedule();
      });

      function destroy() {
        stopped = true;
        observer.disconnect();
        changes.forEach(({ source, result }, node) => {
          if (node.nodeValue === result) node.nodeValue = source;
        });
        changes.clear();
      }

      this.destroyTranslation = destroy;
      window.wauzyTeeTranslations = { destroy };
      apply();
    }
    disconnectedCallback() {
      if (this.destroyTranslation) this.destroyTranslation();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
